import axios from 'axios';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.sub__form');
  if (!form) return;

  const emailInput = form.querySelector('input[name="email"]');

  // Зняти .error при фокусі
  emailInput.addEventListener('focus', () => {
    emailInput.classList.remove('error');
  });

  form.addEventListener('submit', async e => {
    e.preventDefault();

    const email = emailInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      emailInput.classList.add('error');
      return;
    }

    const formData = new FormData();
    formData.append('action', 'send_subscribe');
    formData.append('email', email);

    try {
      const res = await axios.post('/wp-admin/admin-ajax.php', formData);
      const errorTxt = form.dataset.err;

      if (res.data.success) {
        const ttl = form.dataset.ttl;
        const txt = form.dataset.txt;
        Toastify({
          node: (() => {
            const box = document.createElement('div');
            box.className = 'suxxesSub';
            box.innerHTML = `
              <h3 class="custom-toast__title">${ttl}</h3>
              <p class="custom-toast__desc">${txt}</p>
            `;
            return box;
          })(),
          duration: 5000,
          gravity: 'bottom', // top or bottom
          position: 'right', // left, center or right
          backgroundColor: '#fff',
          stopOnFocus: true,
          style: {
            borderRadius: '1rem',
            padding: '2rem 2.5rem',
            fontSize: '.875rem',
            width: '31rem',
            maxWidth: 'calc(100vw - 2rem)',
            boxShadow: '0 0 5rem 0 rgba(14, 131, 218, 0.40)',
          },
        }).showToast();

        form.reset();
      } else {
        Toastify({
          text: errorTxt,
          text: message,
          duration: 3000,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true,
          style: {
            background: type === 'error' ? '#e74c3c' : '#27ae60',
            borderRadius: '.5rem',
            padding: '.7rem 1rem',
            fontSize: '.875rem',
          },
        }).showToast();
      }
    } catch (err) {
      Toastify({
        text: errorTxt,
        text: message,
        duration: 3000,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true,
        style: {
          background: type === 'error' ? '#e74c3c' : '#27ae60',
          borderRadius: '.5rem',
          padding: '.7rem 1rem',
          fontSize: '.875rem',
        },
      }).showToast();
    }
  });
});
